"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceDefinitionUdiDeviceIdentifier = void 0;
/**
 * The characteristics, operational status and capabilities of a medical-related component of a medical device.
 */
var DeviceDefinitionUdiDeviceIdentifier = /** @class */ (function () {
    function DeviceDefinitionUdiDeviceIdentifier() {
    }
    return DeviceDefinitionUdiDeviceIdentifier;
}());
exports.DeviceDefinitionUdiDeviceIdentifier = DeviceDefinitionUdiDeviceIdentifier;
